function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDamageYellow = function SvgDamageYellow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1622,
    height: 1436,
    viewBox: "-118 0 1622 1436"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m1193.043 212.088-9.525 8.95C1162.969 263.484 1140.492 311.721 1116 366q-37 82-98.5 225t-101 269.5T877 1054q0 104 42 192t114 139 157.5 51 157.5-51 114-139 42-192q0-56-31.5-162.5t-71-207-91-217.5-76-168.5c-16.317-34.298-30.13-63.091-41.457-86.412",
    style: {
      fill: "red",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1311 0-1 1q-56 9-102 34-42 22-77 58-27 27-326 312.5T356 842q-74 74-132 131-21-14-38-30-28-27-48-62 13 0 22-5 21-12 24-36 5-27-19-49-16-14-37.5-15.5T89 783q-26 16-34 59-6 31 9 69 14 36 47 77 27 33 58 62-13 12-19 18l-21 21q-21 20-48 49-55 60-106 124-39-3-68 25-25 25-25 60t24 60q25 25 60 24.5t60-25.5q29-28 25-68 66-52 124-106 29-27 49-48 12-11 21-21 12-13 18-19 28 31 62 58 41 33 77 47 39 15 70 9 44-7 58-34 10-16 8-38t-15-37q-22-24-50-20-24 4-35 24-6 10-6 22-35-20-62-48-17-18-30-37 67-69 131-132 105-104 251-255t283.5-296T1184 220c-.147.303-.335.733-.482 1.037l9.525-8.95L1193 212q18-19 28-29 36-35 58-77 25-47 33-103l2-1h-1V1h-2z",
    style: {
      fill: "#e8d66b",
      fillOpacity: 1
    }
  }));
};
export default SvgDamageYellow;